import { render, staticRenderFns } from "./TypeWriter.vue?vue&type=template&id=587123fe&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./TypeWriter.vue?vue&type=script&lang=js&"
export * from "./TypeWriter.vue?vue&type=script&lang=js&"
import style0 from "./TypeWriter.vue?vue&type=style&index=0&id=587123fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587123fe",
  null
  
)

export default component.exports